export default __webpack_public_path__ + "static/media/crazy_final.12cac687.mp4";